import React from 'react';

const Cuarto = () => { 
    return (
        <div className='seccion'>
            <h1>PROGRAMAS DE ESTUDIOS - 2025</h1>

            <h4>Materias Plan Institucional - 4to año</h4>

            <div className="contenedor-tablas">
			<table className="tabla-programas">
				<caption>4to Año - Ecologico - Plan 128</caption>
				<tr>

					<th>Materia</th>
					<th>Programa</th>

				</tr>
				
				<tr>

					<td>Matematica</td>
					<td><a href="https://drive.google.com/drive/folders/18E6SFgzKd97diAcezuJruIxUZAseUxDu?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Lengua y Literatura</td>
					<td><a href="https://drive.google.com/drive/folders/15HnARO35hqgwyVqAnrMFk53cWVpwX6_e?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ciencias Biologicas</td>
					<td><a href="https://drive.google.com/drive/folders/12NQXn8eXQQi5d1umrmrS6WCOzKouD9--?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Historia</td>
					<td><a href="https://drive.google.com/drive/folders/1IOtdxqszK-yTl2u-MePzjMZHXH5on6gl?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Geografia</td>
					<td><a href="https://drive.google.com/drive/folders/1N9zk-VWndd39pe2V4Ds6HT3jvVDdBsAw?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ciencias Fisico Quimicas</td>
					<td><a href="https://drive.google.com/drive/folders/1aWb6YboBFktJ2NjO_MFQxyrs4RnG45jX?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ecologia I y Recursos Naturales</td>
					<td><a href="https://drive.google.com/drive/folders/1ZAEDmcVmFC-2OVQ4g5ZeOK7EWoGWsbLQ?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Contaminacion Ambiental</td>
					<td><a href="https://drive.google.com/drive/folders/1dXHdDpgdLgicympbJmKZjmPX2lsMozTP?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Introduccion a la Informatica</td>
					<td><a href="https://drive.google.com/drive/folders/15HRHMSzs2uGxR9O5zi4TfRYPtMJtyRPJ?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ingles Tecnico</td>
					<td><a href="https://drive.google.com/drive/folders/1ovxF0SiPQnoARHOFXEY_00JRC1eEHf1V?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Psicologia</td>
					<td><a href="https://drive.google.com/drive/folders/1wUH4vPGOXNRdN388-2-PuO_jxrLoIHzo?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Educacion Fisica</td>
					<td><a href="https://drive.google.com/drive/folders/1Vxxpr5shLCyY6Lb3sPqE-ZnMKDCqvhRV?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
			</table>
			
			<table className="tabla-programas">
				<caption>4to Año - Humanistico - Plan 182</caption>
				<tr>

					<th>Materia</th>
					<th>Programa</th>

				</tr>
				<tr>

					<td>Literatura</td>
					<td><a href="https://drive.google.com/drive/folders/14xOO_9O0t34MCYmueJsr7L1Fo5E2pPTS?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ingles</td>
					<td><a href="https://drive.google.com/drive/folders/1KpGGRVR9YIIvLzmVfr0fVBVCMiKQebxb?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Edicacion Fisica</td>
					<td><a href="https://drive.google.com/drive/folders/1E2gdl6UWjbVuia6Rh4_Dg6KFOT9wUeeO?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Fisica</td>
					<td><a href="https://drive.google.com/drive/folders/1B1oGwiQ83REzEw0A1ULokywVK-gg2w5t?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Quimica</td>
					<td><a href="https://drive.google.com/drive/folders/1Y2zDv_wgN1YlrDuvzVK4IJsC-_8wl6fH?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Medios de Comunicacion</td>
					<td><a href="https://drive.google.com/drive/folders/1Ulx5wMkJjGRysSRwDedhzsV6Du4GWYnB?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ciencias Biologicas</td>
					<td><a href="https://drive.google.com/drive/folders/1vjZfrEg4w2VJEaYtPho0DzPbbWiRS-jH?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Filosofia</td>
					<td><a href="https://drive.google.com/drive/folders/17y9rZeAmyKbek_zCh-DnuC5i2BDIoxCE?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ciencias Sociales</td>
					<td><a href="https://drive.google.com/drive/folders/1qXg7LB1R7IyP4f2OK2F5aOHZE_IPZDGc?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td style={{ fontSize: '13px' }}>Intro. A la Metodología de la Investigación</td>
					<td><a href="https://drive.google.com/drive/folders/1T-TF304-l-RscR3YxmahqscdtR_5nTHK?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Taller Integrador I</td>
					<td><a href="https://drive.google.com/drive/folders/1jqGkhwRCCOq27pJ1EIF-CdmHVnZQsMI-?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Informatica IV</td>
					<td><a href="https://drive.google.com/drive/folders/1g5CzObY2pCTUvTDeRmhF6wOzMvvfovCq?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

				</tr>

			</table>

		</div>            

        </div>
    );
}

export default Cuarto;
